/**
 * @desc 查询石灰石需求周计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekLimestoneResponse>> {
  return defHttp.post({
    url: '/web/plan/week/queryPlanLimestone',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanWeekLimestoneResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryPlanLimestone',
    data,
  });
}
